export enum TeacherSortEnum {
    OUR_TOP_OFFERS = 'Órafoglaló ajánlása',
    POPULARITY = 'Népszerűség',
    HIGHEST_PRICE = 'Ár: Legmagasabb elől',
    LOWEST_PRICE  ='Ár: Legalacsonyabb elől',
    BY_REVIEWS = 'Értékelések száma alapján',
    BEST_RATING = 'Legjobb értékelés'
}
